import React, { Component } from "react";
import { QueryAssistant } from "../home/home";
import Appbar from "./appbar";
import DemoCarousel from "./carsouel";
import MenuItem from "@material-ui/core/MenuItem";
import CustomizedSelect from "../home/transactions/customizedSelect";
import { Input } from "../forms/input";
import Signbutton from "../forms/button";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {
  saveEmpanelment,
  empanelmentRegistration,
  getCitiesList,
  saveEmpanelmentNomineeData,
} from "../../store/actions/empanelment";
import { connect } from "react-redux";
import CustomLoader from "../forms/Loader";

class NomineeDetails extends Component {
  constructor(props) {
    super(props);
    const { storeCAMSData } = this.props;
    this.state = {
      cities: [],
      loader: false,
      radioValue: { value: "YES" },
      nominee_name: {
        value:
          !!storeCAMSData &&
          storeCAMSData.NomineeDetails[0] &&
          !!storeCAMSData.NomineeDetails[0].Nomineename
            ? storeCAMSData.NomineeDetails[0].Nomineename
            : "",
      },
      nomineeAdd1: {
        value:
          !!storeCAMSData &&
          storeCAMSData.NomineeDetails[0] &&
          !!storeCAMSData.NomineeDetails[0].Nomineename
            ? storeCAMSData.NomineeDetails[0].address
            : "",
      },
      nomineeAdd2: {
        value: "",
      },
      nomineeAdd3: {
        value: "",
      },
      state: {
        value:
          !!storeCAMSData &&
          storeCAMSData.NomineeDetails[0] &&
          !!storeCAMSData.NomineeDetails[0].Nomineename
            ? storeCAMSData.NomineeDetails[0].State
            : "",
      },
      city: {
        value:
          !!storeCAMSData &&
          storeCAMSData.NomineeDetails[0] &&
          !!storeCAMSData.NomineeDetails[0].Nomineename
            ? storeCAMSData.NomineeDetails[0].City
            : "",
      },
      pincode: {
        value:
          !!storeCAMSData &&
          storeCAMSData.NomineeDetails[0] &&
          !!storeCAMSData.NomineeDetails[0].Nomineename
            ? storeCAMSData.NomineeDetails[0].Pincode
            : "",
      },
    };
  }
  async componentDidMount() {
    try {
      this.setState({ loader: true });
      const response = await this.props.getCitiesList();
      if (!!response && !!response.Dtinformation) {
        const cities = response.Dtinformation;
        cities.length > 0 && this.setState({ cities: cities });
      }
    } catch (e) {
      alert(e);
    } finally {
      this.setState({ loader: false });
    }
  }
  fillDetails = () => (event) => {
    if (event.target.value === "YES") {
      this.setState({
        radioValue: { value: "YES" },
        nominee_name: {
          value:
            (!!this.props.storeCAMSData.NomineeDetails[0] &&
              this.props.storeCAMSData.NomineeDetails[0].Nomineename) ||
            "",
        },
        nomineeAdd1: {
          value:
            (!!this.props.storeCAMSData.NomineeDetails[0] &&
              this.props.storeCAMSData.NomineeDetails[0].address) ||
            "",
        },
        nomineeAdd2: {
          value:
            (!!this.props.storeCAMSData.NomineeDetails[0] &&
              this.props.storeCAMSData.NomineeDetails[0].ADDRESS2) ||
            "",
        },
        nomineeAdd3: {
          value:
            (!!this.props.storeCAMSData.NomineeDetails[0] &&
              this.props.storeCAMSData.NomineeDetails[0].ADDRESS3) ||
            "",
        },
        state: {
          value:
            (!!this.props.storeCAMSData.NomineeDetails[0] &&
              this.props.storeCAMSData.NomineeDetails[0].State) ||
            "",
        },
        city: {
          value:
            (!!this.props.storeCAMSData.NomineeDetails[0] &&
              this.props.storeCAMSData.NomineeDetails[0].City) ||
            "",
        },
        pincode: {
          value:
            (!!this.props.storeCAMSData.NomineeDetails[0] &&
              this.props.storeCAMSData.NomineeDetails[0].Pincode) ||
            "",
        },
      });
    } else {
      this.setState({
        nominee_name: {
          value: "",
        },
        radioValue: { value: "NO" },
        nomineeAdd1: { value: "" },
        nomineeAdd2: { value: "" },
        nomineeAdd3: { value: "" },
        state: { value: "" },
        city: { value: "" },
        pincode: { value: "" },
      });
    }
  };
  changeValue = (label) => (event) => {
    this.setState({
      [label]: { value: event.target.value },
    });
  };
  validate = (label) => (event) => {
    if (label === "pincode") {
      if (!/^[1-9][0-9]{5}$/.test(event.target.value)) {
        this.setState({
          pincode: {
            value: "",
            isError: true,
            errorMessage: "Enter a valid Pincode",
          },
        });
      }
    }
  };

  changeCity = (e) => {
    const city = e.target.value;
    this.setState({
      city: { value: city },
    });
  };
  submit = async () => {
    const { radioValue, nomineeAdd2, nomineeAdd3, loader, cities, ...others } =
      this.state;
    const keys = Object.keys(others);
    const findError = keys.every((key) => !!others[key].value);
    if (!/^[1-9][0-9]{5}$/.test(this.state.pincode.value)) {
      this.setState({
        pincode: {
          value: "",
          isError: true,
          errorMessage: "Enter a valid Pincode",
        },
      });
      return;
    }
    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage: `${
                key === "nominee_name"
                  ? "Nominee Name"
                  : key === "nomineeAdd1"
                  ? "Nominee Address"
                  : key === "state"
                  ? "State"
                  : key === "city"
                  ? "City"
                  : key === "pincode"
                  ? "Pincode"
                  : key
              } is mandatory`,
            },
          });
      });
      return;
    }
    const nomineeDetails = {
      nominee_name: this.state.nominee_name.value,
      nominee_add:
        this.state.nomineeAdd1.value +
        this.state.nomineeAdd2.value +
        this.state.nomineeAdd3.value,
      nominee_city: this.state.city.value,
      nominee_pin: this.state.pincode.value,
    };
    await this.props.saveEmpanelmentNomineeData({
      ...nomineeDetails,
    });
    // await this.props.saveNomineeDetails({
    //   ...nomineeDetails,
    // });
    this.props.history.push("/distributor-empanellement/Bajaj-entities", {
      nominee_name: this.state.nominee_name.value,
      nominee_add:
        this.state.nomineeAdd1.value +
        this.state.nomineeAdd2.value +
        this.state.nomineeAdd3.value,
      nominee_city: this.state.city.value,
      nominee_pin: this.state.pincode.value,
    });
  };
  render() {
    const {
      radioValue,
      nominee_name,
      nomineeAdd1,
      nomineeAdd2,
      nomineeAdd3,
      state,
      city,
      pincode,
      cities,
    } = this.state;
    return (
      <div className="login-container">
        {/* <QueryAssistant /> */}
        <Appbar />
        <CustomLoader display={this.state.loader} />
        <div className="login-without-appbar">
          <DemoCarousel />
          <div className="login-right-div" style={{ overflow: "scroll" }}>
            <div>
              <div className="login-title">Nominee Details</div>
              <div className="input-field-container">
                <div className="input-name">Choose an Option*</div>

                <FormControl component="fieldset">
                  <RadioGroup
                    aria-label="Search"
                    name="search"
                    value={radioValue.value}
                    style={{ flexDirection: "row" }}
                    onChange={this.fillDetails("radioValue")}
                  >
                    <div className="investor-radio-button">
                      <FormControlLabel
                        value="YES"
                        control={
                          <Radio
                            className="investor-search-radio"
                            style={{ color: "#005DAC" }}
                          />
                        }
                        className="investor-formcontrol-label"
                        style={{ margin: 0 }}
                      />
                      <div className="investor-form-label">
                        Get the nominee details from CDMS database
                      </div>
                    </div>
                    <div className="investor-radio-button">
                      <FormControlLabel
                        value="NO"
                        control={
                          <Radio
                            className="investor-search-radio"
                            style={{ color: "#005DAC" }}
                          />
                        }
                        className="investor-formcontrol-label"
                        style={{ margin: 0 }}
                      />
                      <div className="investor-form-label">
                        Update Nominee details
                      </div>
                    </div>
                  </RadioGroup>
                </FormControl>
              </div>

              <div className="input-margin">
                <Input
                  maxLength={50}
                  name="Nominee Name*"
                  value={nominee_name.value}
                  onChange={this.changeValue("nominee_name")}
                  isShowError={nominee_name.isError}
                  errorMessage={nominee_name.errorMessage}
                  inputref={(ele) => (this.nameField = ele)}
                  placeholder={"Please enter Nominee Name"}
                />
              </div>

              <div className="input-margin">
                <Input
                  maxLength={50}
                  name="Nominee Address*"
                  value={nomineeAdd1.value}
                  onChange={this.changeValue("nomineeAdd1")}
                  isShowError={nomineeAdd1.isError}
                  errorMessage={nomineeAdd1.errorMessage}
                  inputref={(ele) => (this.nomineeAdd1Field = ele)}
                  placeholder={"Please enter Nominee Address"}
                />
              </div>

              <div className="input-margin">
                <Input
                  maxLength={50}
                  name=""
                  value={nomineeAdd2.value}
                  onChange={this.changeValue("nomineeAdd2")}
                  isShowError={nomineeAdd2.isError}
                  errorMessage={nomineeAdd2.errorMessage}
                  inputref={(ele) => (this.nomineeAdd2Field = ele)}
                />
              </div>
              <div className="input-margin">
                <Input
                  maxLength={50}
                  name=""
                  value={nomineeAdd3.value}
                  onChange={this.changeValue("nomineeAdd3")}
                  isShowError={nomineeAdd3.isError}
                  errorMessage={nomineeAdd3.errorMessage}
                  inputref={(ele) => (this.nomineeAdd3Field = ele)}
                />
              </div>
              <div className="input-margin">
                <Input
                  maxLength={50}
                  name="State*"
                  value={state.value}
                  onChange={this.changeValue("state")}
                  isShowError={state.isError}
                  errorMessage={state.errorMessage}
                  inputref={(ele) => (this.stateField = ele)}
                  placeholder={"Please enter your State"}
                />
              </div>
              <div className="input-margin">
                <CustomizedSelect
                  name="City*"
                  handleChange={this.changeCity}
                  isError={city.isError}
                  errorMessage={city.errorMessage}
                  inputref={(ele) => (this.cityFieled = ele)}
                  value={city.value}
                >
                  {cities.map((s) => (
                    <MenuItem value={s.city}>{s.city}</MenuItem>
                  ))}
                </CustomizedSelect>
              </div>

              <div className="input-margin">
                <Input
                  maxLength={50}
                  name="Pincode*"
                  value={pincode.value}
                  onChange={this.changeValue("pincode")}
                  isShowError={pincode.isError}
                  errorMessage={pincode.errorMessage}
                  inputref={(ele) => (this.pincodeField = ele)}
                  onblur={this.validate("Pincode")}
                  placeholder={"Please enter your pincode"}
                />
              </div>

              {/* <div style={{ width: "100%" }}>
                <div className="input-name">Date of birth</div>

                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    required={true}
                    className="selects"
                    onChange={(e) => this.onDateChange("dob", e)}
                    style={{
                      border:
                        this.state.dob.error === true
                          ? "1px solid red"
                          : "1px solid #a6a6a6",
                      borderTop:
                        this.state.dob.error === true
                          ? "2px solid red"
                          : "2px solid #a6a6a6",
                      borderRadius: this.state.dob.error === true ? 7 : 7,
                    }}
                    disableFuture={true}
                    format="dd/MM/yyyy"
                    maxDate={new Date()}
                    margin="normal"
                    id="mui-pickers-date"
                    value={this.state.dob.value}
                  />
                </MuiPickersUtilsProvider>
              </div> */}

              <Signbutton buttontitle="Submit" onClick={this.submit} />
              <span
                className="login-no-account-span mouse-pointer"
                onClick={() =>
                  this.props.history.push(
                    "/distributor-empanellement/bank-details"
                  )
                }
              >
                Back
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  ({ authReducer }) => {
    const {
      empanelmentData,
      camsdata,
      empanelmentBasicDetails,
      empanelmentBankDetails,
      storeCAMSData,
    } = authReducer;
    return {
      camsdata,
      empanelmentData,
      empanelmentBasicDetails,
      empanelmentBankDetails,
      storeCAMSData,
    };
  },
  {
    saveEmpanelment,
    empanelmentRegistration,
    getCitiesList,
    saveEmpanelmentNomineeData,
  }
)(NomineeDetails);
